<app-dialog-container>
    <div fxLayout="column" fxLayoutGap="24px">
        <!-- Cabeçalho -->
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <h2 mat-dialog-title>Gerar Contrato Avulso</h2>
            <button mat-icon-button (click)="close()" [disabled]="loading">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div mat-dialog-content class="dialog-content">
            <!-- Informação -->
            <p class="info-text">
                <mat-icon>info</mat-icon>
                Contratos avulsos permitem gerar contratos personalizados
                opcionalmente vinculados a clientes ou parceiros.
            </p>

            <!-- Formulário Principal -->
            <form [formGroup]="contractForm" fxLayout="column" fxLayoutGap="16px">
                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutAlign="start center">
                    <mat-form-field appearance="outline" fxFlex="70" fxFlex.lt-md="100">
                        <mat-label>Título do Contrato</mat-label>
                        <input matInput formControlName="title" placeholder="Ex: Contrato de Prestação de Serviços">
                        <mat-icon matSuffix>title</mat-icon>
                        <mat-error *ngIf="contractForm.get('title')?.hasError('required')">Título é
                            obrigatório</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="30" fxFlex.lt-md="100">
                        <mat-label>Tipo</mat-label>
                        <mat-select formControlName="type">
                            <mat-option value="" disabled>Selecionar o tipo de contrato</mat-option>
                            <mat-option value="automatic">Automático</mat-option>
                            <mat-option value="manual">Manual</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Upload de Template -->
                <div class="section-card">
                    <h3>
                        <mat-icon>description</mat-icon>
                        Template do Contrato
                    </h3>
                    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
                        <button mat-raised-button color="primary" type="button" (click)="fileInput.click()"
                            [disabled]="loading">
                            <mat-icon>upload_file</mat-icon>
                            Selecionar Arquivo
                        </button>
                        <input #fileInput type="file" hidden accept=".docx,.doc,.pdf"
                            (change)="onTemplateFileSelect($event)">
                        <span *ngIf="templateFileName" class="file-name">
                            <mat-icon>insert_drive_file</mat-icon>
                            {{ templateFileName }}
                        </span>
                        <button *ngIf="templateFile" mat-icon-button color="warn" type="button"
                            (click)="clearTemplateFile()" matTooltip="Remover arquivo">
                            <mat-icon>close</mat-icon>
                        </button>
                         <span fxFlex></span>
                        <app-input fxFlex="30" fxFlex.lt-md="100" 
                            [config]="getFieldConfig('templatesActives')" [typeCes]="typeCes" [group]="variablesForm"
                            (onSelect)="selectContractActive()">
                        </app-input>
                    </div>
                    <mat-hint>Formatos aceitos: DOCX, DOC</mat-hint>
                </div>
            </form>

            <!-- MOCK / TIRAR DEPOIS -->
            <!-- <div>
                <h3>Testes (Preencher Mock):</h3>
                <button type="button" (click)="fillFormWithMockCPF()">
                    Carregar Mock (Assinante CPF)
                </button>
                
                <button type="button" (click)="fillFormWithMockCNPJ()">
                    Carregar Mock (Assinante CNPJ)
                </button>
                
                <button type="button" (click)="clearForm()">
                    Limpar Formulário
                </button>
            </div> -->

            <div>
                <button type="button" mat-raised-button color="primary" (click)="clearForm()" 
                *ngIf="contractForm.get('type')?.value !== 'manual'">
                    Limpar Formulário
                </button>
            </div>



            <form [formGroup]="variablesForm" fxLayout="column" fxLayoutGap="24px"
                *ngIf="contractForm.get('type')?.value !== 'manual'">

                <div class="section-card">
                    <h3>
                        <mat-icon>person</mat-icon>
                        Dados do Contratado
                    </h3>
                    <div fxLayout="row wrap" fxLayoutGap="16px grid">
                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('subscriberName')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('subscriberDocument')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('subscriberDocumentType')" [typeCes]="typeCes"
                            [group]="variablesForm">
                        </app-input>


                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('subscriberEmail')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('subscriberTelephone')" [typeCes]="typeCes"
                            [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('subscriberPhone')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('subscriberAddressNumber')" [typeCes]="typeCes"
                            [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('subscriberCity')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('subscriberState')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('subscriberCep')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>
                    </div>
                </div>

                <div class="section-card">
                    <h3>
                        <mat-icon>handshake</mat-icon>
                        Dados do Contratante
                    </h3>
                    <div fxLayout="row wrap" fxLayoutGap="16px grid">
                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('contractorName')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('contractorDocument')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('contractorEmail')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('contractorTelephone')" [typeCes]="typeCes"
                            [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('contractorAddress')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('contractorCity')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('contractorState')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('contractorNameContract')" [typeCes]="typeCes"
                            [group]="variablesForm">
                        </app-input>

                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('contractorDocumentContract')" [typeCes]="typeCes"
                            [group]="variablesForm">
                        </app-input>
                    </div>
                </div>
                <div class="section-card">
                    <h3>
                        <mat-icon>date_range</mat-icon>
                        Datas
                    </h3>
                    <div fxLayout="row wrap" fxLayoutGap="16px grid">
                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100" [config]="getFieldConfig('dueDate')"
                            [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>
                        <app-input fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="100"
                            [config]="getFieldConfig('firstDueDate')" [typeCes]="typeCes" [group]="variablesForm">
                        </app-input>
                    </div>
                </div>

            </form>
            <div class="section-card" *ngIf="contractForm.get('type')?.value !== 'manual'">
                <h3>
                    <mat-icon>link</mat-icon>
                    Vincular a Cliente ou Parceiro (Opcional)
                </h3>
                <p class="section-description">
                    Opcionalmente você pode vincular este contrato a um cliente
                    ou parceiro para usar suas informações no template.
                </p>

                <div fxLayout="row" fxLayoutGap="16px" fxLayout.lt-md="column">
                    <button mat-raised-button color="accent" (click)="selectCustomer()"
                        [disabled]="loading || !!selectedEntity">
                        <mat-icon>person</mat-icon>
                        Selecionar Cliente
                    </button>
                    <button mat-raised-button color="accent" (click)="selectPartner()"
                        [disabled]="loading || !!selectedEntity">
                        <mat-icon>handshake</mat-icon>
                        Selecionar Parceiro
                    </button>
                </div>

                <!-- Informações da Entidade Selecionada -->
                <div *ngIf="selectedEntity" class="entity-info">
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="entity-header">
                        <h4>
                            <mat-icon>{{ entityType === 'customer' ? 'person' :
                                'handshake' }}</mat-icon>
                            {{ entityType === 'customer' ? 'Cliente' :
                            'Parceiro' }} Selecionado
                        </h4>
                        <button mat-icon-button color="warn" (click)="clearEntity()" matTooltip="Remover vínculo">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="16px grid" class="entity-details">
                        <div fxFlex="calc(50% - 16px)" fxFlex.lt-md="100">
                            <strong>Nome:</strong>
                            {{ entityType === 'customer' ?
                            (selectedEntity.companyName || selectedEntity.name)
                            : (selectedEntity.name ||
                            selectedEntity.companyName) }}
                        </div>
                        <div fxFlex="calc(50% - 16px)" fxFlex.lt-md="100">
                            <strong>Documento:</strong> {{
                            selectedEntity.document || selectedEntity.cnpj ||
                            selectedEntity.cpf }}
                        </div>
                        <div fxFlex="calc(50% - 16px)" fxFlex.lt-md="100">
                            <strong>Email:</strong> {{ selectedEntity.email }}
                        </div>
                        <div fxFlex="calc(50% - 16px)" fxFlex.lt-md="100">
                            <strong>Telefone:</strong> {{
                            selectedEntity.cellPhone || selectedEntity.phone }}
                        </div>
                    </div>

                    <!-- Planos do Cliente -->
                    <div *ngIf="entityType === 'customer' && customerPlans.length > 0" class="plans-section">
                        <h4>Selecione um Plano</h4>
                        <div fxLayout="row wrap" fxLayoutGap="16px grid">
                            <div *ngFor="let plan of customerPlans" fxFlex="calc(33.33% - 16px)"
                                fxFlex.lt-lg="calc(50% - 16px)" fxFlex.lt-md="100" class="plan-card"
                                [class.selected]="selectedPlan?.id === plan.id" (click)="onPlanSelect(plan)">
                                <div class="plan-header">
                                    <h5>{{ plan.system?.name }}</h5>
                                    <span class="plan-type">{{ plan.type === 1 ?
                                        'Sistema' : 'Módulo' }}</span>
                                </div>
                                <div class="plan-info">
                                    <div class="info-row">
                                        <span>Terminais:</span>
                                        <strong>{{ plan.terminalQuantity
                                            }}</strong>
                                    </div>
                                    <div class="info-row">
                                        <span>Valor Mensal:</span>
                                        <strong>R$ {{ plan.monthlyValue |
                                            number:'1.2-2' }}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Tipos de Contrato do Parceiro -->
                    <div *ngIf="entityType === 'partner' && partnerRoles.length > 0" class="partner-roles-section">
                        <h4>Selecione o Tipo de Contrato</h4>
                        <div fxLayout="row wrap" fxLayoutGap="16px grid">
                            <div *ngFor="let role of partnerRoles" fxFlex="calc(33.33% - 16px)"
                                fxFlex.lt-lg="calc(50% - 16px)" fxFlex.lt-md="100" class="role-card"
                                [class.selected]="selectedPartnerRole?.type === role.type"
                                [class.disabled]="role.hasActiveContract" (click)="onPartnerRoleSelect(role)">
                                <div class="role-header">
                                    <h5>{{ role.label }}</h5>
                                    <span *ngIf="role.hasActiveContract" class="badge-signed">Assinado</span>
                                    <span *ngIf="role.contractStatus && !role.hasActiveContract" class="badge-status">
                                        {{ role.contractStatus }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section-card" *ngIf="contractForm.get('type')?.value !== 'manual'">
                <h3>
                    <mat-icon>workspace_premium</mat-icon>
                    Planos(Opcional)
                </h3>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                    <button mat-raised-button class="select-plan-button" (click)="openModalPlans()"
                        title="SELECIONAR PLANO">
                        <mat-icon>search</mat-icon>
                        <span>SELECIONAR</span>
                    </button>
                </div>
                <div *ngIf="plansStandalone.length > 0 && customerPlans.length <= 0" class="plans-section">
                        <h4>Plano Selecionado</h4>
                        <div fxLayout="row wrap" fxLayoutGap="16px grid">
                            <div *ngFor="let plan of plansStandalone" fxFlex="calc(33.33% - 16px)"
                                fxFlex.lt-lg="calc(50% - 16px)" fxFlex.lt-md="100" class="plan-card"
                                [class.selected]="selectedPlan?.id === plan.id" (click)="onPlanSelect(plan)">
                                <div class="plan-header">
                                    <h5>{{ plan.system?.name }}</h5>
                                    <span class="plan-type">{{ plan.type === 1 ?
                                        'Sistema' : 'Módulo' }}</span>
                                </div>
                                <div class="plan-info">
                                    <div class="info-row">
                                        <span>Terminais:</span>
                                        <strong>{{ plan.terminalQuantity
                                            }}</strong>
                                    </div>
                                    <div class="info-row">
                                        <span>Valor Mensal:</span>
                                        <strong>R$ {{ plan.monthlyValue |
                                            number:'1.2-2' }}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>


            <!-- Variáveis Disponíveis -->
            <div class="section-card variables-section" *ngIf="contractForm && contractForm.contains('variables')">
                <h3>
                    <mat-icon>code</mat-icon>
                    Variáveis Disponíveis para o Template
                </h3>
                <p class="section-description">
                    Use estas variáveis no seu template DOCX. Elas serão
                    substituídas automaticamente pelos valores correspondentes.
                </p>

                <mat-accordion>
                    <mat-expansion-panel *ngFor="let category of availableVariables">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ category.category }}
                                <mat-chip class="variable-count">{{
                                    category.variables.length }}</mat-chip>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="variables-list">
                            <div *ngFor="let variable of category.variables" class="variable-item" fxLayout="row"
                                fxLayoutAlign="space-between center">
                                <div fxFlex="grow">
                                    <code class="variable-name">{{ variable.name
                                        }}</code>
                                    <span class="variable-description">{{
                                        variable.description }}</span>
                                </div>
                                <button mat-icon-button color="primary" (click)="copyVariable(variable.name)"
                                    matTooltip="Copiar variável">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>

            <!-- Seção de Assinaturas -->
            <div class="section-card">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <h3>
                        <mat-icon>draw</mat-icon>
                        Assinaturas
                    </h3>
                    <button mat-raised-button color="primary" (click)="addSignature()" [disabled]="loading">
                        <mat-icon>add</mat-icon>
                        Adicionar Assinante
                    </button>
                </div>

                <div class="table-container">
                    <table mat-table [dataSource]="signatures" class="signatures-table">
                        <!-- Nome -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Nome</th>
                            <td mat-cell *matCellDef="let signature">{{
                                signature.name }}</td>
                        </ng-container>

                        <!-- Email -->
                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef>E-mail</th>
                            <td mat-cell *matCellDef="let signature">{{
                                signature.email }}</td>
                        </ng-container>

                        <!-- Documento -->
                        <ng-container matColumnDef="document">
                            <th mat-header-cell *matHeaderCellDef>Documento</th>
                            <td mat-cell *matCellDef="let signature">{{
                                signature.document }}</td>
                        </ng-container>

                        <!-- Tipo -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef>Tipo</th>
                            <td mat-cell *matCellDef="let signature">
                                <span class="signature-type-badge">
                                    {{ getSignatureTypeLabel(signature.type) }}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Ações -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Ações</th>
                            <td mat-cell *matCellDef="let signature; let i = index">
                                <button mat-icon-button color="primary" (click)="editSignature(signature, i)"
                                    [disabled]="loading" matTooltip="Editar">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="removeSignature(i)" [disabled]="loading"
                                    matTooltip="Remover">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Mensagem quando não há assinaturas -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                                <div class="no-data-message">
                                    <mat-icon>info</mat-icon>
                                    Adicione assinantes ao contrato
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <!-- Loading -->
            <div *ngIf="isLoading" class="loading-overlay">
                <mat-spinner diameter="50"></mat-spinner>
                <p>Carregando...</p>
            </div>
        </div>

        <!-- Ações do Diálogo -->
        <div mat-dialog-actions fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="end center">
            <button mat-button (click)="close()" [disabled]="loading">
                <mat-icon>close</mat-icon>
                Cancelar
            </button>
            <button mat-raised-button color="primary" (click)="generateContract()"
                [disabled]="loading || !contractForm.valid  || signatures.data.length === 0">
                <mat-spinner *ngIf="loading" diameter="20" class="button-spinner"></mat-spinner>
                <mat-icon *ngIf="!loading">send</mat-icon>
                {{ loading ? 'Gerando...' : 'Gerar Contrato' }}
            </button>
        </div>
    </div>
</app-dialog-container>